var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 647,
    viewBox: "0 0 1440 647",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("rect", {
    y: 350,
    width: 72,
    height: 297,
    fill: "url(#paint0_linear_26_3311)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 302,
    width: 72,
    height: 345,
    fill: "url(#paint1_linear_26_3311)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 245,
    width: 72,
    height: 402,
    fill: "url(#paint2_linear_26_3311)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 175,
    width: 72,
    height: 472,
    fill: "url(#paint3_linear_26_3311)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 227,
    width: 72,
    height: 420,
    fill: "url(#paint4_linear_26_3311)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 162,
    width: 72,
    height: 485,
    fill: "url(#paint5_linear_26_3311)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 128,
    width: 72,
    height: 519,
    fill: "url(#paint6_linear_26_3311)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 128,
    width: 72,
    height: 519,
    fill: "url(#paint7_linear_26_3311)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 96,
    width: 72,
    height: 551,
    fill: "url(#paint8_linear_26_3311)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 72,
    width: 72,
    height: 575,
    fill: "url(#paint9_linear_26_3311)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 96,
    width: 72,
    height: 551,
    fill: "url(#paint10_linear_26_3311)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 175,
    width: 72,
    height: 472,
    fill: "url(#paint11_linear_26_3311)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 197,
    width: 72,
    height: 450,
    fill: "url(#paint12_linear_26_3311)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 128,
    width: 72,
    height: 519,
    fill: "url(#paint13_linear_26_3311)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 72,
    width: 72,
    height: 575,
    fill: "url(#paint14_linear_26_3311)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    width: 72,
    height: 647,
    fill: "url(#paint15_linear_26_3311)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    width: 72,
    height: 647,
    fill: "url(#paint16_linear_26_3311)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 72,
    width: 72,
    height: 575,
    fill: "url(#paint17_linear_26_3311)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 210,
    width: 72,
    height: 437,
    fill: "url(#paint18_linear_26_3311)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 302,
    width: 72,
    height: 345,
    fill: "url(#paint19_linear_26_3311)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_3311",
    x1: 36,
    y1: 350,
    x2: 36,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26_3311",
    x1: 108,
    y1: 302,
    x2: 108,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26_3311",
    x1: 180,
    y1: 245,
    x2: 180,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26_3311",
    x1: 252,
    y1: 175,
    x2: 252,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26_3311",
    x1: 324,
    y1: 227,
    x2: 324,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26_3311",
    x1: 396,
    y1: 162,
    x2: 396,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26_3311",
    x1: 468,
    y1: 128,
    x2: 468,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26_3311",
    x1: 540,
    y1: 128,
    x2: 540,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_26_3311",
    x1: 612,
    y1: 96,
    x2: 612,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_26_3311",
    x1: 684,
    y1: 72,
    x2: 684,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_26_3311",
    x1: 756,
    y1: 96,
    x2: 756,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_26_3311",
    x1: 828,
    y1: 175,
    x2: 828,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_26_3311",
    x1: 900,
    y1: 197,
    x2: 900,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_26_3311",
    x1: 972,
    y1: 128,
    x2: 972,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_26_3311",
    x1: 1044,
    y1: 72,
    x2: 1044,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_26_3311",
    x1: 1116,
    y1: 0,
    x2: 1116,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_26_3311",
    x1: 1188,
    y1: 0,
    x2: 1188,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_26_3311",
    x1: 1260,
    y1: 72,
    x2: 1260,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_26_3311",
    x1: 1332,
    y1: 210,
    x2: 1332,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_26_3311",
    x1: 1404,
    y1: 302,
    x2: 1404,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgChart);
export default __webpack_public_path__ + "static/media/bg-chart.d8f0fda765d3326cfa8ea450d8195391.svg";
export { ForwardRef as ReactComponent };